import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import team from '@/../i18n/en/team.json';

const resources = {
  en: {
    team,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
